import styled from 'styled-components/native'

export const Container = styled.View`
  background-color: ${props => props.theme.colors.white};
  justify-content: center;
  height: 100%;
`
